import Model from "../../Model";

export interface TFormStructureSection {
  attributeCode: string;
  attributeName: string;
  attributeOrderNumber: number;
  level: number;
  orderNumber: number;
  qualifierCode: string;
  qualifierName: string;
  qualifierOrderNumber: number;
  sectionId: number;
  sectionLabel: string;
  sectionName: string;
  superiorSectionId: number;
  formStructureSections: IFormStructureSection[];
}

export interface IFormStructureSection extends TFormStructureSection {
  fullName: string;
  isSelectable: boolean;
}

const FormStructureSection = Model(
  (model: TFormStructureSection): IFormStructureSection => {
    const _formStructure: TFormStructureSection = Object.assign({}, model);

    return {
      get attributeCode() {
        return _formStructure.attributeCode;
      },
      set attributeCode(value) {
        _formStructure.attributeCode = value;
      },
      get attributeName() {
        return _formStructure.attributeName;
      },
      set attributeName(value) {
        _formStructure.attributeName = value;
      },
      get attributeOrderNumber() {
        return _formStructure.attributeOrderNumber;
      },
      set attributeOrderNumber(value) {
        _formStructure.attributeOrderNumber = value;
      },
      get level() {
        return _formStructure.level;
      },
      set level(value) {
        _formStructure.level = value;
      },
      get orderNumber() {
        return _formStructure.orderNumber;
      },
      set orderNumber(value) {
        _formStructure.orderNumber = value;
      },
      get qualifierCode() {
        return _formStructure.qualifierCode;
      },
      set qualifierCode(value) {
        _formStructure.qualifierCode = value;
      },
      get qualifierName() {
        return _formStructure.qualifierName;
      },
      set qualifierName(value) {
        _formStructure.qualifierName = value;
      },
      get qualifierOrderNumber() {
        return _formStructure.qualifierOrderNumber;
      },
      set qualifierOrderNumber(value) {
        _formStructure.qualifierOrderNumber = value;
      },
      get sectionId() {
        return _formStructure.sectionId;
      },
      set sectionId(value) {
        _formStructure.sectionId = value;
      },
      get sectionLabel() {
        return _formStructure.sectionLabel;
      },
      set sectionLabel(value) {
        _formStructure.sectionLabel = value;
      },
      get sectionName() {
        return _formStructure.sectionName;
      },
      set sectionName(value) {
        _formStructure.sectionName = value;
      },
      get superiorSectionId() {
        return _formStructure.superiorSectionId;
      },
      set superiorSectionId(value) {
        _formStructure.superiorSectionId = value;
      },
      get formStructureSections() {
        return _formStructure.formStructureSections;
      },
      set formStructureSections(value) {
        _formStructure.formStructureSections = value;
      },
      get fullName() {
        return `${_formStructure.sectionLabel}${
          _formStructure.qualifierName
            ? ` - ${_formStructure.qualifierName}`
            : ""
        }${
          _formStructure.attributeName
            ? ` - ${_formStructure.attributeName}`
            : ""
        }`;
      },
      get isSelectable() {
        const containsFiled =
          _formStructure.qualifierCode && _formStructure.attributeCode
            ? true
            : false;
        return containsFiled;
      }
    };
  }
);

export default FormStructureSection;
